import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ToolBar from '@/components/bussiness/ToolBar.vue'
import VipLevel from './index.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ToolBar, { class: "tool-bar" }),
    _createVNode(VipLevel, { isInvitatePage: true })
  ], 64))
}
}

})